// COMMENT: CREATE THIS FILE
export const LOADING_PHARMACIES_NAME = "LOADING_PHARMACIES_NAME";
export const GET_PHARMACIES_NAME_SUCCESS = "GET_PHARMACIES_NAME_SUCCESS";
export const GET_PHARMACIES_NAME_FAILURE = "GET_PHARMACIES_NAME_FAILURE";